

import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import AttachMoney from '@material-ui/icons/AttachMoney';


import CampaignSetup from "./CampaignSetup";
import logo from '../../../../assets/img/sonicleadgen.png';
import AddCreditDialog from '../../AddCreditDialog'


function isEmpty(obj) {

  if (obj){
    return Object.keys(obj).length === 0 ;
  }
  return true
}


const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100%',
  },
  flex: {
    flex: 1,
  },
  logo: {
    height: 50,
    marginLeft: theme.spacing.unit,
  },
  appFrame: {
    height: '100%',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    width: '100%',
  },
  appBar: {
    position: 'absolute',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  menuButton: {
    marginLeft: 12,
    marginRight: 20,
  },
  hide: {
    display: 'none',
  },

  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,

  },

});

@inject("commonStore")
@inject("authStore")
@observer
class ManageCampaign extends Component {
  state = {
  };

 
  render() {
    const { classes, theme, commonStore } = this.props;
    const { anchor, open, showTabs, showBalanceDialog } = this.state;
    const { agent } = commonStore

    return (
      <div className={classes.root}>
    
        <div className={classes.appFrame}>
          <AppBar color="default" className={classNames(classes.appBar)}>
            <Toolbar disableGutters={!open}>
            <Typography variant="title" color="inherit" className={classes.flex}>
            <img src={logo} className={classes.logo}/>
            </Typography>
          <Typography>
          {`Account Credit: $${(agent.credit / 100).toLocaleString()}`}
          </Typography>
          <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={() => {this.openDialog('addCredit')}}
          className={classNames(classes.menuButton, open && classes.hide)}
        >
        <AttachMoney />
        </IconButton>
            </Toolbar>

          </AppBar>
          <main className={classNames(classes.content)}>
            <div className={classes.drawerHeader} />
           
            <CampaignSetup {...this.state}/>
          
            </main>
        </div>

      </div>
    );
  }
}

ManageCampaign.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(ManageCampaign);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/index.js